import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { stringify } from 'qs'
import { CmsBlogArticle } from 'types/cms/collection-types'

/**
 * Get the blog articles from the CMS
 *
 * @param {'all' | Language} locale
 * @param {string} producerSlug
 * @returns {Promise<CmsBlogArticle[]>}
 */
const getBlogArticles = async (locale: 'all' | Language = Language.DUTCH, producerSlug?: string): Promise<CmsBlogArticle[]> => {
  try {
    const query = stringify(
      {
        ...(!!producerSlug && {
          filters: {
            producerSlug: {
              $eq: producerSlug
            }
          }
        }),
        locale
      },
      {
        addQueryPrefix: true,
        skipNulls: true
      }
    )

    const { data } = await axios.get<CMSApiResponseBody<CmsBlogArticle[]>>(`${process.env.CMS_API_URL}/blog-articles${query}`)

    return data.data
  } catch (_) {
    return []
  }
}

export default getBlogArticles
